<template>
  <status-template
    :title="$t('title')"
    :description="$t('description')"
    :imageUrl="require(`@/assets/kyc/step_1.svg`).default"
  />
</template>
<script>
export default {
  name: 'Pending',
  components: {
    StatusTemplate: () => import('./StatusTemplate.vue')
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "title": "Estamos analisando as informações",
      "description": "Agora é só aguardar. Em algumas horas o resultado da análise vai estar disponível."
    },
    "en-US": {
      "title": "We are analysing the information",
      "description": "For now just wait. In a few hours the analysis result will be available here."
    }
  }
</i18n>
